```
author:wangrongfeng1@163.com
```
<template>
  <div>

    <full-page
      :options="options"
      ref="fullpage"
    >
      <!-- 第一屏 -->
       <div class="section sec1">
        <header1></header1>
        <!-- trigger="click" -->
        <el-carousel
          arrow="arrow"
          :interval="3000"
          :height="heightel"
          class="carousel"
        >
          <el-carousel-item
            v-for="(item,i) of bannerListOne"
            :key="i"
          >
            <div class="carDiv">

              <img
                class="home1Logo"
                src="../../../static/image/home1-logo.png"
                alt=""
              >
              <img
                class="img"
                :src="item.banner_img"
                alt=""
              >
            </div>
            <!-- :src="item.banner_img" -->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 第二屏 -->
      <div
        class="section sec2"
        :style="'background: url('+TwoNav.backgroundImg+') no-repeat center;background-size: cover;'"
      >
        <div class="titletop">
          <div class="nav">
            <ul
              ref="uls"
              :class="ulWidth?'ul':''"
              v-if="language==1"
              key="lang"
            >
              <li
                class="li"
                v-for="(item,i) in navList"
                :key="i"
                @click="navClick(item)"
              >
                <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
                <p class="EN">{{item.navbar_name_en}}</p>
              </li>
            </ul>
            <div
              class="nav navEn"
              v-else-if="language==2"
              key="lang"
            >
              <ul
                ref="uls"
                :class="ulWidth?'ul':''"
              >
                <li
                  class="li"
                  v-for="(item,i) in navList"
                  :key="i"
                  @click="navClick(item)"
                >
                  <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="square">

          <div :class="rightindex==1?'child':'child childslide'">

          </div>
          <div
            :class="rightindex==1?'child':'child childslide'"
            v-for="(item,i) of TwoNav.list"
            :key="i"
            @click="TwoClick(item)"
          >
            <div class="understandMore">
              <img
                class="img"
                :src="item.classification_img"
                alt=""
              >
              <p class="text">{{TwoNav.LearnMore}}</p>
              <!-- <p class="text">understand more</p> -->
            </div>
            <div class="sort">
              <img
                class="img"
                :src="item.classification_icon"
                alt=""
                srcset=""
              >
              <p class="p">{{item.classification_name_cn}}</p>
            </div>
          </div>
          <div :class="rightindex==1?'child':'child childslide'">

          </div>

        </div>
      </div>
      <!-- 第三屏 -->
      <div class="section sec3">
        <div class="nav">
          <ul
            ref="uls"
            :class="ulWidth?'ul':''"
            v-if="language==1"
            key="lang"
          >
            <li
              class="li"
              v-for="(item,i) in navList"
              :key="i"
              @click="navClick(item)"
            >
              <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              <p class="EN">{{item.navbar_name_en}}</p>
            </li>
          </ul>
          <div
            class="nav navEn"
            v-else-if="language==2"
            key="lang"
          >
            <ul
              ref="uls"
              :class="ulWidth?'ul':''"
            >
              <li
                class="li"
                v-for="(item,i) in navList"
                :key="i"
                @click="navClick(item)"
              >
                <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div
            class="child"
            v-for="(item,i) in threeNav.list.slice(0,3)"
            :key="i"
            @click="TwoClick(item)"
          >
            <img
              class="sec3Img"
              :src="item.classification_img"
              alt=""
            >
            <!-- :style="'background: url('+item.backimg+') no-repeat center;background-size: cover;'" -->
            <div :class="rightindex==2?'pt':'pt1'">
              <p class="cnName">{{item.classification_name_cn}}</p>
              <p class="enName">{{item.classification_name_en}}</p>
            </div>
          </div>
        </div>
        <div class="div2">
          <div
            class="child"
            v-for="(item,i) in threeNav.list.slice(3)"
            :key="i"
            @click="TwoClick(item)"
          >
            <img
              class="sec3Img"
              :src="item.classification_img"
              alt=""
            >
            <!-- :style="'background: url('+item.backimg+') no-repeat center;background-size: cover;'" -->
            <div :class="rightindex==2?'pt':'pt1'">
              <p class="cnName">{{item.classification_name_cn}}</p>
              <p class="enName">{{item.classification_name_en}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 第四屏 -->
      <div
        class="section sec4"
        :style="'background: url('+fourNav.backgroundImg+') no-repeat center;background-size: cover;'"
      >
        <div class="nav">
          <ul
            ref="uls"
            :class="ulWidth?'ul':''"
            v-if="language==1"
            key="lang"
          >
            <li
              class="li"
              v-for="(item,i) in navList"
              :key="i"
              @click="navClick(item)"
            >
              <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              <p class="EN">{{item.navbar_name_en}}</p>
            </li>
          </ul>
          <div
            class="nav navEn"
            v-else-if="language==2"
            key="lang"
          >
            <ul
              ref="uls"
              :class="ulWidth?'ul':''"
            >
              <li
                class="li"
                v-for="(item,i) in navList"
                :key="i"
                @click="navClick(item)"
              >
                <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="content4">
          <div class="stitle">
            <p class="p">{{fourNav.titleFour}}</p>
            <img
              src="../../../static/image/zhuangshi2.png"
              alt=""
            >
          </div>
          <ul class="numSchool">
            <li
              class="li"
              v-for="(item,i) of fourNav.list"
              :key="i"
            >
              <a
                :href="item.classification_url"
                target="_blank"
              >
                <div class="imgcon">
                  <img
                    class="img"
                    :src="item.classification_icon"
                    alt=""
                  >
                </div>
                <p class="titlep">{{item.classification_name_cn}}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 第五屏 -->
      <div class="section footerH sec5">
        <div class="nav">
          <ul
            ref="uls"
            :class="ulWidth?'ul':''"
            v-if="language==1"
            key="lang"
          >
            <li
              class="li"
              v-for="(item,i) in navList"
              :key="i"
              @click="navClick(item)"
            >
              <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              <p class="EN">{{item.navbar_name_en}}</p>
            </li>
          </ul>
          <div
            class="nav navEn"
            v-else-if="language==2"
            key="lang"
          >
            <ul
              ref="uls"
              :class="ulWidth?'ul':''"
            >
              <li
                class="li"
                v-for="(item,i) in navList"
                :key="i"
                @click="navClick(item)"
              >
                <p :class="!ulWidth1?'CN':'CN CNSize'">{{item.navbar_name_cn}}</p>
              </li>
            </ul>
          </div>
        </div>
        <el-carousel
          :interval="3000"
          type="card"
          arrow="never"
          @change="carou"
          class="el-swi"
        >
          <!-- height='700px' -->
          <el-carousel-item
            v-for="(item,i) of footBanner"
            :key="i"
          >
            <img
              @click="carouselItem(item)"
              class="img"
              :src="item.cover_img"
              alt=""
              srcset=""
            >
          </el-carousel-item>
        </el-carousel>
        <div class="footers">
          <div class="footersTop">
            <img
              class="logo"
              src="../../../static/image/logo3.png"
              alt=""
            >
            <div class="footerMiddle">
              <p class="p1">{{footCon[0].classification_name_cn}}</p>
              <p class="address">
                <img
                  src="../../../static/image/address1.png"
                  alt=""
                >
                <span>{{footCon[0].children[0]}}</span>
              </p>
              <p class="phone">
                <img
                  src="../../../static/image/phone1.png"
                  alt=""
                >
                <span>{{footCon[0].children[1]}}</span>
              </p>
              <p class="letter">
                <img
                  src="../../../static/image/letter1.png"
                  alt=""
                >
                <span>{{footCon[0].children[2]}}</span>
              </p>
            </div>
            <div class="footerRight">
              <p class="p2">
                {{footCon[1].classification_name_cn}}
              </p>
              <div class="link">
                <a
                  v-for="(item,i) of footCon[1].children"
                  :key="i"
                  :href="item.classification_url"
                  :title="item.classification_name_cn"
                  target="_blank"
                >
                  <span
                    class="ellipsis"
                    :title="item.classification_name_cn"
                  >{{item.classification_name_cn}}</span>
                </a>

              </div>
            </div>
          </div>
          <div class="footersBottom">
            <span class="holder">
              成都市新津区成外学校版权所有 <a href="http://www.beian.miit.gov.cn" target="_blank">蜀ICP备20023405号-1</a> 
            </span>
            <!-- <img
              class="gongan"
              src="../../../static/image/gongan.png"
              alt=""
            >
            <span class="caseNumber">
              蜀ICP备20023405号-1
            </span> -->
          </div>
        </div>
      </div>

    </full-page>
    <div class="floatDiv">

      <div class="weixin">
        <img
          class="img"
          :src="rightNav[0].classification_icon"
          alt=""
          srcset=""
        >
        <p class="p">{{rightNav[0].classification_name_cn}}</p>
        <!-- 二维码 -->
        <img
          class="ewm"
          :src="rightNav[0].classification_img"
          alt=""
        >
      </div>
      <div class="yvyue">
        <img
          class="img"
          :src="rightNav[1].classification_icon"
          alt=""
          srcset=""
        >
        <p class="p">{{rightNav[1].classification_name_cn}}</p>
        <!--预约参观-->
        <div class="form">
          <el-input
            type="text"
            class="input"
            :placeholder="rightNav[1].children[0]"
            v-model="rightData.appointment_name"
            clearable
          ></el-input>
          <el-input
            type="text"
            class="input"
            :placeholder="rightNav[1].children[1]"
            v-model="rightData.appointment_birthday"
            clearable
          ></el-input>
          <!-- onfocus="(this.type='date')"
            onblur="(this.type='text')" -->
          <!-- <el-date-picker
            class="cascader input"
            v-model="rightData.appointment_birthday"
            type="date"
            :placeholder="rightNav[1].children[1]"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker> -->
          <el-input
            type="number"
            class="input"
            :placeholder="rightNav[1].children[2]"
            v-model="rightData.guardian_phone"
            clearable
          ></el-input>
          <el-input
            type="text"
            class="input"
            :placeholder="rightNav[1].children[3]"
            v-model="rightData.relation"
            clearable
          ></el-input>
          <el-button
            class="btn"
            @click="rightSubmit"
          >{{rightNav[1].children[4]}}</el-button>
        </div>
      </div>
      <div
        :class="rightindex>0?'top':'topbat'"
        @click="scollTopW()"
      >
        <img
          class="img"
          :src="rightNav[2].classification_icon"
          alt=""
          srcset=""
        >
        <p class="p">{{rightNav[2].classification_name_cn}}</p>
      </div>
    </div>
    <!-- 重要通知 -->
    <ImportantNotice></ImportantNotice>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import "../../../static/css/fullpage.min.css";
import header1 from "../../layout/AppHeaderOne";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { NavgetList } from "@/api/Navbar";
import {
  ClassificationGetList,
  BannerGetList,
  VisitAppointment
} from "@/api/home";
import { GalleryGetList } from "@/api/Album";
import ImportantNotice from "../../layout/ImportantNotice";
export default {
  name: "Index",
  data() {
    return {
      // label: process.env.LABEL,
      options: {
        // 为每个section设置背景色
        //sectionsColor: ["#f00","#0f0","#00f"],
        //用来控制slide幻灯片的箭头，设置为false，两侧的箭头会消失
        controlArrows: false,
        //每一页幻灯片的内容是否垂直居中
        verticalCentered: false,
        //字体是否随着窗口缩放而缩放
        resize: true,
        //页面滚动速度
        //scrollingSpeed: 700,
        //定义锚链接，用户可以快速打开定位到某一页面；不需要加"#"，不要和页面中任意的id和name相同
        //anchors: ["page1","page2","page3"],
        //是否锁定锚链接
        //lockAnchors: true,
        //定义section页面的滚动方式，需要引入jquery.easings插件
        //easing:,
        //是否使用css3 transform来实现滚动效果
        //css3: false,
        //滚动到最顶部后是否连续滚动到底部
        // loopTop: true,
        //滚动到最底部后是否连续滚动到顶部
        // loopBottom:true,
        //横向slide幻灯片是否循环滚动
        //loopHorizontal: false,
        //是否循环滚动，不会出现跳动，效果很平滑
        //continuousVertical: true,
        //是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
        //autoScrolling: false,
        //是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
        //scrollBar: true,
        //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
        // paddingTop: "0px",
        //设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
        paddingBottom: "0px",
        //固定的元素，为jquery选择器；可用于顶部导航等
        //fixedElements: ".nav",
        //是否可以使用键盘方向键导航
        //keyboardScrolling: false,
        //在移动设置中页面敏感性，最大为100，越大越难滑动
        //touchSensitivity: 5,
        //设为false，则通过锚链接定位到某个页面不再有动画效果
        //animateAnchor: false,
        //是否记录历史，可以通过浏览器的前进后退来导航
        //recordHistory: true,
        //绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
        //menu: '.nav',
        //是否显示导航，设为true会显示小圆点作为导航
        //navigation: true,
        //导航小圆点的位置，可以设置为left或者right
        //navigationPosition: right,
        //鼠标移动到小圆点上时显示出的提示信息
        //navigationTooltips: ["第一页","第二页","第三页"],
        //是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
        //showActiveTooltip: true,
        //是否显示横向幻灯片的导航
        slidesNavigation: true,
        //横向幻灯片导航的位置，可以为top或者bottom
        // slidesNavPosition: "bottom",
        //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
        scrollOverflow: false,
        //section选择器
        //sectionSelector: ".section",
        //slide选择器
        //slideSelector: ".slide"
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        afterLoad: this.afterLoad, //滚动到某一屏后的回调函数
        scrollOverflow: false, //内容超过满屏后显示滚动条
        navigation: false, //是否显示导航，默认为false
        navigationPosition: "left", //导航小圆点的位置
        scrollBar: false, //true则是一滚动就是一整屏
        keyboardScrolling: false, //是否可以使用键盘方向键导航，默认为true
        continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
        menu: "#menu"
        // navigation: true,
        // anchors: ['page1', 'page2', 'page3'],
        // sectionsColor: [
        //   '#41b883',
        //   '#ff5f45',
        //   '#0798ec',
        //   '#fec401',
        //   '#1bcee6',
        //   '#ee1a59',
        //   '#2c3e4f',
        //   '#ba5be9',
        //   '#b4b8ab'
        // ]
      },
      rightindex: 0, //第几屏
      carouselIndex: 0, //相册第几个
      heightel: "0", //第一屏轮播图高度
      navList: [], //导航栏
      TwoNav: [], //第二屏
      threeNav: { list: [] }, //第三屏
      fourNav: [], //第四屏
      ulWidth: false, //判定ul类名
      ulWidth1: false, //判定中文类名
      bannerListOne: [], //第一屏banner
      footBanner: [], //最后一屏相册
      footCon: [{ children: {} }, { children: {} }], //底部导航栏
      rightNav: [{}, { children: {} }, {}], //右边导航栏
      rightData: {
        appointment_name: "", //姓名
        appointment_birthday: "", //出生日期
        guardian_phone: "", //电话
        relation: "" //关系
      },
      language: 1 //导航语言
    };
  },
  computed: {
    ...mapState("user", ["headerHeight"])
  },
  components: {
    header1,
    ImportantNotice
  },
  methods: {
    afterLoad(origin, destination, direction) {
      // console.log('After load....');
      // console.log(destination.index);
      this.rightindex = destination.index;
    },
    scollTopW() {
      this.$refs.fullpage.api.moveTo(1);
    },
    carou(pre, next) {
      this.carouselIndex = pre;
      // console.log(pre,next)
    },
    // 点击相册跳转
    carouselItem(item) {
      // console.log(item, this.carouselIndex);
      if (item - 1 == this.carouselIndex) {
        // console.log("12324324");
      }
      var laber = [0, 18];
      var laPath = ["/"];
      var routeData = this.$router.resolve({
        path: "/GalleryDetail",
        query: {
          id: item.album_id,
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
        }
      });

      window.open(routeData.href, "_blank");
      // query: { laber: JSON.stringify(laber) }
    },
    // 监听浏览器高度宽度变化
    getHeight() {
      if (this.$refs.uls) {
        if (this.$refs.uls.offsetWidth < 1300) {
          this.ulWidth = true;
        } else {
          this.ulWidth = false;
        }
        if (this.$refs.uls.offsetWidth <= 1100) {
          this.ulWidth1 = true;
        } else {
          this.ulWidth1 = false;
        }
      }
      //   console.log(this.headerHeight, "dfsf");
      this.heightel = window.innerHeight - this.headerHeight + "px";
    },
    // 导航栏跳转
    navClick(item) {
      this.$router.push({ path: item.navbar_url });
    },
    // 第二屏跳转
    TwoClick(item) {
      this.$router.push({ path: item.classification_url });
    },
    // 第三屏跳转
    // ThreeClick(item) {
    //   this.$router.push({ path: item.path });
    // },
    // 获取各板块内容
    Plate(i, x) {
      ClassificationGetList({
        address: i,
        limit: x
      }).then(res => {
        if (i == 1) {
          this.TwoNav = res.data;
        } else if (i == 2) {
          this.threeNav = res.data;
        } else if (i == 3) {
          this.fourNav = res.data;
        } else if (i == 4) {
          this.footCon = res.data.list;
        } else if (i == 5) {
          // console.log(res);
          this.rightNav = res.data.list;
        }
      });
    },
    // 首页及底部banner图
    Banner(i) {
      BannerGetList({ address: i }).then(res => {
        this.bannerListOne = res.data;
      });
    },
    // 提交表单
    rightSubmit() {
      if (this.rightData.appointment_name.length < 2) {
        this.$message.error("姓名填写不正确");
        return;
      }
      if (
        this.rightData.guardian_phone.length < 11 ||
        this.rightData.guardian_phone.length > 11
      ) {
        this.$message.error("电话填写不正确");
        return;
      }
      VisitAppointment(this.rightData).then(res => {
        // console.log(res);
        if (res.code == 1) {
          this.$confirm(res.msg, "提示", {
            confirmButtonText: "确定",
            // cancelButtonText: '取消',
            type: "success",
            showClose: false,
            showCancelButton: false
          });
        } else {
          this.$confirm(res.msg, "警告", {
            confirmButtonText: "确定",
            // cancelButtonText: '取消',
            type: "error",
            showClose: false,
            showCancelButton: false
          });
        }
      });
    },
    // 相册
    GalleryList() {
      GalleryGetList({
        address: 1,
        per_page: 5
      }).then(res => {
        // console.log(res.data);
        this.footBanner = res.data.list;
      });
    }
  },
  created() {},
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    NavgetList({}).then(res => {
      // console.log(res)
      this.navList = res.data;
    });
    // 第二屏内容
    this.Plate(1, 4);
    // 第三屏内容
    this.Plate(2, 5);
    // // 第四屏内容
    this.Plate(3, 4);
    // 底部导航栏
    this.Plate(4, 6);
    // 右侧功能栏
    this.Plate(5, 3);

    // 首页banner图
    this.Banner(1);
    // 底部相册图
    this.GalleryList();
    this.language = Number(sessionStorage["lang"]);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.sec1 {
  // .top1{
  //   height: 20.2%;
  // }
  /deep/ .el-carousel {
    // height: 79.8%;
    .el-carousel__container {
      height: 100%;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .el-carousel__indicator {
      padding: 20px 6px;
      .el-carousel__button {
        width: 80px;
        height: 4px;
        border-radius: 2px;
      }
    }
    .is-active {
      .el-carousel__button {
        background-color: #e2bb81;
      }
    }
  }
  .carDiv {
    position: relative;
    height: 100%;
    .home1Logo {
      display: block;
      position: absolute;
      width: px2Rem(135px);
      height: px2Rem(190px);
      z-index: 9;
      top: 17.5%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
// px2Rem(258px)
.sec2 {
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    // z-index: 3;
    top: 0;
    left: 0;
    transition: 0.3s;
  }
  .nav .li {
    &:first-of-type {
      color: #e2bb81;
    }
    &:hover {
      color: #e2bb81;
    }
  }
  .square {
    position: relative;
    height: 90%;
    .child {
      position: absolute;
      width: px2Rem(258px);
      height: px2Rem(258px);
      transform: rotate(45deg);
      background: rgba(224, 192, 144, 0.4);
      opacity: 0.4;
      border-radius: 4px;
      left: 2.5%;
      top: 45%;
      transition: 1s;
      opacity: 1;
      visibility: visible;
      cursor: pointer;
      animation-timing-function: ease-out;
      // overflow: hidden;
      &::after {
        position: absolute;
        display: block;
        background: rgba(224, 192, 144, 0);
        content: "";
        width: 100%;
        height: 100%;
        padding: 10px;
        top: -10px;
        left: -10px;
        border: 1px rgba(224, 192, 144, 1) dashed;
      }
      &:nth-of-type(2) {
        animation-delay: 0.5s;
        background: rgba(252, 253, 255, 0.9);
        left: 18.5%;
        top: 15%;
      }
      &:nth-of-type(3) {
        animation-delay: 1s;
        background: rgba(252, 253, 255, 0.9);
        left: 35%;
      }
      &:nth-of-type(4) {
        animation-delay: 1.5s;
        background: rgba(252, 253, 255, 0.9);
        top: 15%;
        left: 50%;
      }
      &:nth-of-type(5) {
        animation-delay: 2s;
        background: rgba(252, 253, 255, 0.9);
        left: 65%;
      }
      &:nth-of-type(6) {
        animation-delay: 2.5s;
        // background:rgba(252,253,255,1);
        left: 80%;
        top: 15%;
      }
      .understandMore {
        position: absolute;
        width: 0%;
        height: 0%;
        // transform: rotate(-45deg);
        opacity: 0;
        visibility: hidden;
        transition: 0.5s;
        overflow: hidden;
        .img {
          position: absolute;
          width: 100%;
          height: 100%;
          transform: rotate(-45deg) scale(1.4);
        }
        .text {
          position: absolute;
          width: 100%;
          max-height: px2Rem(72px);
          top: 43%;
          left: 0%;
          right: 0;
          margin: auto;
          // right: px2Rem(40px);
          color: #fff;
          font-size: px2Rem(34px);
          // font-family: STXinwei;
          font-weight: 400;
          // transform: translate(-50%, -50%);
          transform: rotate(-45deg);
          text-align: center;
        }
      }
      .sort {
        position: absolute;
        width: 100%;
        top: 20%;
        // left: 10%;
        transform: rotate(-45deg);
        text-align: center;
        transition: 0.5s;
        opacity: 1;
        visibility: visible;
        .img {
          display: inline-block;
          width: px2Rem(102px);
          height: px2Rem(86px);
        }
        .p {
          margin-top: px2Rem(15px);
          font-size: px2Rem(34px);
          // font-family:STXinwei;
          font-weight: 400;
          color: rgba(28, 50, 120, 1);
        }
      }
      &:hover {
        .understandMore {
          width: 100%;
          height: 100%;
          opacity: 1;
          visibility: visible;
          // transform: rotate(-45deg) scale(1.5);
          // .text{
          //   transform: rotate(0deg) scale(0.8);
          // }
        }
        .sort {
          width: 0;
          // height: 0;
          opacity: 0;
          visibility: hidden;
          transform: scale(0);
        }
      }
    }
    .childslide {
      top: 80%;
      opacity: 0;
      visibility: hidden;
      z-index: -999;
      &:nth-of-type(2n) {
        top: -100%;
      }
    }
  }
}
.sec3 {
  // z-index: 2;
  font-size: 0px;
  .nav .li {
    color: #696969;
    &:first-of-type {
      color: rgba(28, 50, 120, 1);
    }
    &:hover {
      color: rgba(28, 50, 120, 1);
    }
  }
  .sec3Img {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: 1s;
    z-index: -1;
  }
  .div1 {
    // display: flex;
    width: 100%;
    height: 46.2%;
    font-size: 0px;
    cursor: pointer;
    .child {
      position: relative;
      display: inline-block;
      height: 100%;
      width: 33.333%;
      overflow: hidden;
      vertical-align: top;
      &:hover {
        .sec3Img {
          transform: scale(1.1);
        }
        &::before {
          background-color: rgba(0, 0, 0, 0);
        }
      }

      &::before {
        display: block;
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        // z-index: 3;
        top: 0;
        left: 0;
        transition: 0.3s;
        // z-index: 1;
      }
      .pt {
        position: absolute;
        width: 100%;
        top: 35%;
        left: 0;
        transition: 0.5s;
        visibility: visible;
        opacity: 1;
        text-align: center;
        transition: 1s;
        .cnName {
          position: relative;
          margin-bottom: px2Rem(50px);
          font-size: px2Rem(34px);
          font-weight: bold;
          color: rgba(253, 253, 255, 1);
          &::before {
            display: block;
            position: absolute;
            content: "";
            width: px2Rem(50px);
            height: 3px;
            top: 150%;
            left: 46%;
            background: rgba(253, 253, 255, 1);
          }
        }
        .enName {
          font-size: px2Rem(18px);
          font-family: Arial;
          font-weight: 400;
          color: rgba(253, 253, 255, 1);
        }
      }
    }
  }
  .pt1 {
    position: absolute;
    transition: 0.5s;
    left: 50%;
  }
  .div2 {
    // display: flex;
    width: 100%;
    height: 46.2%;
    font-size: 0px;
    cursor: pointer;
    .child {
      position: relative;
      display: inline-block;
      height: 100%;
      width: 50%;
      overflow: hidden;
      vertical-align: top;
      &:hover {
        .sec3Img {
          transform: scale(1.1);
        }
        &::before {
          background-color: rgba(0, 0, 0, 0);
        }
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        // z-index: 999;
        top: 0;
        left: 0;
        transition: 0.3s;
      }
      .pt {
        position: absolute;
        width: 100%;
        top: 35%;
        left: 0;
        transition: 1s;
        visibility: visible;
        opacity: 1;
        text-align: center;
        .cnName {
          position: relative;
          margin-bottom: px2Rem(50px);
          font-size: px2Rem(34px);
          font-weight: bold;
          color: rgba(253, 253, 255, 1);
          &::before {
            display: block;
            position: absolute;
            content: "";
            width: px2Rem(50px);
            height: 3px;
            top: 150%;
            left: 46%;
            background: rgba(253, 253, 255, 1);
          }
        }
        .enName {
          font-size: px2Rem(18px);
          font-family: Arial;
          font-weight: 400;
          color: rgba(253, 253, 255, 1);
        }
      }
    }
  }
}
.sec4 {
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    // z-index: 3;
    top: 0;
    left: 0;
    transition: 0.3s;
  }
  .nav .li {
    &:first-of-type {
      color: #e2bb81;
    }
    &:hover {
      color: #e2bb81;
    }
  }
  .content4 {
    .stitle {
      position: relative;
      margin-top: 8%;
      margin-bottom: 3.9%;
      p {
        margin-bottom: px2Rem(60px);
        font-size: px2Rem(60px);
        color: rgba(255, 255, 255, 1);
        &:nth-of-type(2) {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .numSchool {
      position: relative;
      font-size: 0;
      text-align: center;
      .li {
        display: inline-block;
        width: px2Rem(220px);
        margin-right: px2Rem(140px);
        font-size: px2Rem(34px);
        font-weight: 400;
        cursor: pointer;
        transition: 0.5s;
        vertical-align: top;
        .titlep {
          // word-wrap:break-word;
          word-break: break-all;
          color: rgba(255, 255, 255, 1);
        }
        &:hover {
          transform: scale(1.1);
        }
        &:last-of-type {
          margin-right: 0;
          .imgcon {
            background: rgba(136, 201, 121, 0.8);
          }
        }
        &:nth-of-type(1) {
          .imgcon {
            background: rgba(146, 201, 232, 0.8);
          }
        }
        &:nth-of-type(2) {
          .imgcon {
            background: rgba(255, 168, 174, 0.8);
          }
        }
        &:nth-of-type(3) {
          .imgcon {
            background: rgba(226, 187, 129, 0.8);
          }
        }
        .imgcon {
          height: px2Rem(220px);
          margin-bottom: px2Rem(20px);
          padding-top: 0.1px;
          .img {
            display: block;
            width: px2Rem(126px);
            height: px2Rem(133px);
            margin: auto;
            margin-top: px2Rem(44px);
          }
        }
      }
    }
  }
}
.sec5 {
  background: #f5f5f5;
  .nav {
    background: #fff;
  }
  .nav .li {
    color: #696969;
    &:first-of-type {
      color: rgba(28, 50, 120, 1);
    }
    &:hover {
      color: rgba(28, 50, 120, 1);
    }
  }
  /deep/ .el-carousel {
    // height: px2Rem(700px);
    margin-top: px2Rem(20px);
    background: #f5f5f5;
    height: 60%;
  }
  /deep/ .el-carousel__container {
    height: 100%;
  }
  /deep/ .el-carousel__indicators--outside {
    display: none;
  }
  .el-swi {
    .img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .footers {
    position: absolute;
    height: 20%;
    width: 100%;
    bottom: 0;
    padding-top: px2Rem(30px);
    // background: #f5f5f5;
    color:rgba(255,255,255,1);
    background:rgba(51,51,56,1);
    .footersTop {
      width: px2Rem(1300px);
      margin: auto;
      font-size: 0;
      .logo {
        display: inline-block;
        width: px2Rem(187px);
        height: px2Rem(140px);
        vertical-align: bottom;
      }
      .footerMiddle {
        display: inline-block;
        width: px2Rem(400px);
        margin: 0 px2Rem(90px) 0 px2Rem(270px);
        text-align: left;
        vertical-align: top;
        .p1 {
          position: relative;
          margin-bottom: px2Rem(25px);
          font-size: px2Rem(24px);
          font-weight: 400;
          color:rgba(255,255,255,1);
          &::before {
            display: block;
            content: "";
            position: absolute;
            bottom: px2Rem(-10px);
            width: px2Rem(30px);
            height: 3px;
            background: rgba(255,255,255, 1);
            border-radius: 2px;
          }
        }
        p {
          font-size: px2Rem(18px);
          font-weight: 400;
        }
        .address {
          img {
            width: px2Rem(16px);
            height: px2Rem(16px);
            vertical-align: top;
          }
        }
        .phone {
          margin: px2Rem(10px) 0;
          img {
            width: px2Rem(16px);
            height: px2Rem(16px);
            vertical-align: top;
          }
        }
        .letter {
          img {
            width: px2Rem(16px);
            height: px2Rem(12px);
            vertical-align: top;
          }
        }
        img {
          margin-right: px2Rem(10px);
        }
        // span{
        //   display: inline-block;
        //   width: px2Rem(325px);
        // }
      }
      .footerRight {
        display: inline-block;
        vertical-align: top;
        .p2 {
          position: relative;
          margin-bottom: px2Rem(25px);
          font-size: px2Rem(24px);
          font-weight: 400;
          color:rgba(255,255,255,1);
          &::before {
            display: block;
            content: "";
            position: absolute;
            bottom: px2Rem(-10px);
            width: px2Rem(30px);
            height: 3px;
            background: rgba(255,255,255,1);
            border-radius: 2px;
          }
        }
        .link {
          width: px2Rem(300px);
          span {
            display: inline-block;
            width: px2Rem(148px);
            margin-bottom: px2Rem(17px);
            color: rgba(255,255,255,1);
            font-size: px2Rem(18px);
            font-weight: 400;
            vertical-align: top;
          }
          a:hover {
            span {
              color: #e2bb81;
            }
          }
        }
      }
    }
    .footersBottom {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: px2Rem(10px);
      text-align: center;
      font-size: px2Rem(16px);
      font-weight: 400;
      color: rgba(255,255,255,1);

      .holder {
        margin-right: px2Rem(30px);
        a{
         color: #fff;
        }
      }
      span {
        display: inline-block;
      }
      .gongan {
        display: inline-block;
        width: 15px;
        height: 15px;
        vertical-align: middle;
      }
    }
  }
}
.floatDiv {
  position: fixed;
  // width: 100px;
  // height: 100px;
  padding-top: 0.1px;
  right: 0px;
  top: 40%;
  z-index: 9;
  font-size: px2Rem(24px);
  // font-family: STXinwei;
  font-weight: 400;
  color: rgba(28, 50, 120, 1);
  .top {
    width: px2Rem(140px);
    height: px2Rem(100px);
    margin-top: 0;
    background: rgba(255, 255, 255, 1);
    opacity: 0.8;
    border-radius: 8px 0px 0px 8px;
    text-align: center;
    cursor: pointer;
    transition: 0.5s;
    visibility: visible;
  }
  .topbat {
    width: 0;
    height: 0;
    margin-top: 15%;
    opacity: 0;
    visibility: hidden;
    transition: 0.5s;
  }
  .weixin {
    position: relative;
    width: px2Rem(140px);
    padding-bottom: px2Rem(15px);
    // height: px2Rem(100px);
    background: rgba(255, 255, 255, 1);
    opacity: 0.8;
    border-radius: 8px 0px 0px 8px;
    text-align: center;
    cursor: pointer;
    .ewm {
      display: block;
      position: absolute;
      top: px2Rem(-305px);
      left: px2Rem(-305px);
      width: px2Rem(300px);
      height: px2Rem(300px);
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);
      transition: 0.5s;
      opacity: 0;
      visibility: hidden;
    }
    &:hover {
      .ewm {
        top: px2Rem(0px);
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .img {
    display: inline-block;
    width: px2Rem(50px);
    height: px2Rem(42px);
    margin-top: px2Rem(15px);
  }
  .yvyue {
    position: relative;
    width: px2Rem(140px);
    padding-bottom: px2Rem(15px);
    margin: 4px 0;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px 0px 0px 8px;
    text-align: center;
    cursor: pointer;
    &:hover {
      .form {
        top: px2Rem(-165px);
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .form {
    position: absolute;
    width: px2Rem(320px);
    // height: px2Rem(324px);
    padding: px2Rem(30px);
    left: px2Rem(-385px);

    top: px2Rem(-265px);
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    opacity: 0;
    visibility: hidden;
    transition: 0.5s;
    .input {
      display: block;
      width: px2Rem(308px);
      height: px2Rem(44px);
      // padding-left: 10px;
      margin-bottom: px2Rem(20px);
      border: 1px solid rgba(205, 205, 205, 1);
      font-size: px2Rem(24px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      // font-family: STXinwei;
      /deep/ input {
        width: px2Rem(308px);
        height: px2Rem(44px);
        padding-left: 10px;
        padding-right:10px;
        margin-bottom: px2Rem(20px);
        border: 0px solid rgba(205, 205, 205, 1);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      /deep/ .el-input__icon{
        line-height: px2Rem(44px) !important;
      }
    }
    .btn {
      display: block;
      // padding :px2Rem(12px) px2Rem(130px);
      width: px2Rem(320px);
      height: px2Rem(50px);
      margin-top: px2Rem(10px);
      background: rgba(226, 187, 129, 1);
      font-size: px2Rem(30px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
.nav {
  position: relative;
  // font-family: STXinwei;
  // z-index: 9;
  ul {
    // display: flex;
    display: flex;
    position: relative;
    width: px2Rem(1300px);
    min-width: 1100px;
    margin: auto;
    padding: px2Rem(20px) 0;
    font-size: 0;
    text-align: center;
  }
  .li {
    display: inline-block;
    font-size: 0;
    cursor: pointer;
    vertical-align: top;
    text-align: center;
    white-space: nowrap;
    color: #fff;
    transition: 0.5s;
    .CN {
      font-size: px2Rem(24px);
      font-weight: 400;
    }
    .CNSize {
      font-size: 18px;
    }
    .EN {
      padding-top: px2Rem(5px);
      font-size: 12px;
      font-family: Arial;
      font-weight: 400;
      // color: #fff;
    }
    &:nth-of-type(1) {
      margin-right: 5%;
    }
    &:nth-of-type(2) {
      margin-right: 3%;
    }
    &:nth-of-type(3) {
      margin-right: 1.8%;
    }
    &:nth-of-type(4) {
      margin-right: 2%;
    }
    &:nth-of-type(5) {
      margin-right: 0.8%;
    }
    &:nth-of-type(6) {
      margin-right: px2Rem(9px);
    }
    &:nth-of-type(7) {
      margin-right: 3%;
    }
    &:nth-of-type(8) {
      margin-right: 3.5%;
    }
    &:nth-of-type(9) {
      margin-right: 2%;
    }
    &:nth-of-type(10) {
      // margin-right: 2%;
      // float: right;
      position: absolute;
      right: 0;
    }
  }
  .ul {
    .li {
      &:nth-of-type(1) {
        margin-right: 3%;
      }
      &:nth-of-type(7) {
        margin-right: 2.2%;
      }
      &:nth-of-type(8) {
        margin-right: 2.2%;
      }
    }
  }
}
.navEn {
  .ul {
    // display: block;
    .li {
      // width: 110px;
      .CNSize {
        font-size: 14px;
      }
    }
  }
  .li {
    // max-width: px2Rem(130px);
    white-space: normal;
    vertical-align: top;
    margin-right: 2% !important;
    &:last-of-type {
      position: relative;
      margin-right: 0 !important;
      text-align: right;
    }
    &:first-of-type {
      text-align: left;
    }
    .CN {
      // font-family:Arial;
      font-size: px2Rem(18px);
    }
  }
}
img{
  object-fit: cover;
}
/deep/ input[type="number"]::-webkit-outer-spin-button,
/deep/ input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
input[type="date"]::-webkit-inner-spin-button {
  visibility: hidden;
}

</style>


// WEBPACK FOOTER //
// src/views/index/Index.vue